import GraphicAndTextSlide from './layouts/GraphicAndTextSlide.comp';
import StepBlockSlide from './layouts/StepBlockSlide.comp';
import ListSlide from './layouts/ListSlide.comp';
import LongTextSlide from './layouts/LongTextSlide.comp';
import SubtitleSlide from './layouts/SubtitleSlide.comp';
import VideoSlide from './layouts/VideoSlide.comp';
import PollQuizSlide from './layouts/PollQuizSlide.comp';
import JournalingSlide from './layouts/JournalingSlide.comp';
import DiscussionSlide from './layouts/DiscussionSlide.comp';
import AssessmentResultSlide from './layouts/AssessmentResultSlide.comp';
import RecapSlide from './layouts/RecapSlide.comp';
import ReentryMapSlide from './layouts/ReentryMapSlide.comp';
import WorkedExampleSlide from './layouts/WorkedExampleSlide.comp';
import DecisionPointSlide from './layouts/DecisionPointSlide.comp';
import AnalysisFrameworkSlide from './layouts/AnalysisFrameworkSlide.comp';
import SessionStartSlide from './layouts/SessionStartSlide.comp';
import PledgeSlide from './layouts/PledgeSlide.comp';
import ShareWorkSlide from './layouts/ShareWorkSlide.comp';
import HtmlContentSlide from './layouts/HtmlContent/HtmlContentSlide.comp';

export const slideRegistry = {
  TemplateGraphicAndText: GraphicAndTextSlide,
  TemplateStepBlock: StepBlockSlide,
  TemplateList: ListSlide,
  TemplateLongText: LongTextSlide,
  TEMPLATE_WITH_SUBTITLE: SubtitleSlide,
  VideoTemplate: VideoSlide,
  POLL_QUIZ_ACTIVITY: PollQuizSlide,
  JOURNALING_SELF_REFLECTION_ACTIVITY: JournalingSlide,
  DISCUSSION_ACTIVITY: DiscussionSlide,
  ASSESSMENT_RESULT: AssessmentResultSlide,
  TemplateRecap: RecapSlide,
  TemplateReentryMap: ReentryMapSlide,
  TemplateWorkedExample: WorkedExampleSlide,
  TemplateDecisionPoint: DecisionPointSlide,
  TemplateAnalysisFramework: AnalysisFrameworkSlide,
  TemplateSessionStart: SessionStartSlide,
  PledgeTemplate: PledgeSlide,
  SHARE_WORK_FILE_ACTIVITY: ShareWorkSlide,
  TemplateHtmlContent: HtmlContentSlide,
};

export const getEffectiveLayout = (slide) => {
  if (!slide) return null;
  const origin = slide._pbdq_origin || slide;
  const slideType = (origin.slide_type || slide._pbdq_kind || '').toLowerCase();
  const isCaseStudy =
    slideType === 'case_study' ||
    slide._pbdq_kind === 'case_study' ||
    origin.slide_type === 'case_study' ||
    slide.slide_type === 'case_study' ||
    Boolean(origin.case_snippet || origin.case_title || slide.case_snippet || slide.case_title);

  let effectiveLayout = slide.SlideLayout;
  // Case studies, hands-on labs, practice overviews, skill maps, real-system examples and before-you-start notes
  // only have a renderer in HtmlContentSlide, whatever SlideLayout says.
  if (isCaseStudy || slideType === 'hands_on_lab' || slideType === 'practice_overview' || slideType === 'theme_map'
      || slideType === 'example_artifact' || slideType === 'prep_guide') {
    effectiveLayout = 'TemplateHtmlContent';
  } else if (!effectiveLayout) {
    if (slide.VideoUrl || slideType === 'video' || slideType === 'intro_video') effectiveLayout = 'VideoTemplate';
    else if (slideType === 'poll_quiz' || slideType === 'poll' || slideType === 'intro_poll' || slideType === 'tied_poll' || slideType === 'fun_poll') effectiveLayout = 'POLL_QUIZ_ACTIVITY';
    else if (slideType === 'discussion' || slideType === 'group_discussion') effectiveLayout = 'DISCUSSION_ACTIVITY';
    else if (slideType === 'reflection' || slideType === 'journaling') effectiveLayout = 'JOURNALING_SELF_REFLECTION_ACTIVITY';
    else if (slideType === 'share_work' || slideType === 'design_challenge') effectiveLayout = 'SHARE_WORK_FILE_ACTIVITY';
    else if (slideType === 'pledge') effectiveLayout = 'PledgeTemplate';
    else if (slideType === 'recap' || slideType === 't7_recap') effectiveLayout = 'TemplateRecap';
    else if (slideType === 'reentry_map' || slideType === 'closing') effectiveLayout = 'TemplateReentryMap';
    else if (slideType === 'decision_point') effectiveLayout = 'TemplateDecisionPoint';
    else if (slideType === 'worked_example') effectiveLayout = 'TemplateWorkedExample';
    else if (slideType === 'analysis_framework') effectiveLayout = 'TemplateAnalysisFramework';
    else effectiveLayout = 'TemplateHtmlContent';
  }

  return effectiveLayout;
};

export const getSlideComponent = (slide) => {
  const layout = getEffectiveLayout(slide);
  return slideRegistry[layout] || null;
};

export default slideRegistry;
